import { createFileRoute } from '@tanstack/react-router'
import { OperatorsTab } from '~/components/routes/visioReviews/OperatorsTab'
import { VisioReviewsLayout } from '~/components/routes/visioReviews/VisioReviewsLayout'
import {
  useVisioReviewsPeriod,
  visioReviewsSearchSchema,
} from '~/components/routes/visioReviews/search'
import { VISIO_REVIEWS_TAB_PERMISSIONS } from '~/components/routes/visioReviews/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/visio-reviews/operateur')({
  staticData: {
    permission: VISIO_REVIEWS_TAB_PERMISSIONS.operateur,
  },
  validateSearch: visioReviewsSearchSchema,
  component: VisioReviewsOperateurPage,
})
withRoutePermissions(Route)

function VisioReviewsOperateurPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const { dateRange, previousPeriod } = useVisioReviewsPeriod(search)

  return (
    <VisioReviewsLayout
      activeTab="operateur"
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    >
      <OperatorsTab dateRange={dateRange} previousPeriod={previousPeriod} />
    </VisioReviewsLayout>
  )
}
